module.exports = "/assets/data/e568ea4200c95de20828312841fc34e1-SW3.data.json";